export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl border border-background-200 p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">投稿与合作</h2>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6">
                妖精漫画网欢迎漫画创作者和爱好者投稿交流。无论你是独立漫画作者、翻译组还是漫画相关内容创作者，都可以通过以下方式与我们取得联系，共同为漫画社区贡献力量。
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-4">
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-mail-line text-accent-500"></i>
                  </span>
                  <span>contact@yaojingmh.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100">
                    <i className="ri-wechat-line text-primary-500"></i>
                  </span>
                  <span>妖精漫画官方</span>
                </div>
              </div>
            </div>
            <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 flex items-center justify-center rounded-2xl bg-secondary-100">
              <i className="ri-send-plane-line text-3xl md:text-4xl text-secondary-500"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}